import { IUserTransactions } from "@api/types/userTransactions";
import { useLazyQuery } from "@apollo/client";
import { GET_USER_TRANSACTIONS } from "@graphql/Queries";
import { toastErrorMessage } from "@utils/utils";
import { useCallback, useState } from "react";
import useReduxState from "./useReduxState";

export default function useFetchUserTransactions(): [
  // eslint-disable-next-line no-unused-vars
  (userId: string) => Promise<void>,
  // eslint-disable-next-line no-unused-vars
  (data: IUserTransactions) => void
] {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [transactions, setTransactions] = useReduxState(
    (state) => state.userTransactions
  );
  const [fetchTransactions] = useLazyQuery(GET_USER_TRANSACTIONS, {
    onCompleted: (data) => {
      toggleIsFetching(false);
      updateTransactions(data.getUserTransactions);
    },
    onError: (e) => {
      toggleIsFetching(false);
      toastErrorMessage(e.message);
    },
  });

  const updateTransactions = useCallback(
    (data: IUserTransactions) => {
      setTransactions({
        type: "SET_USER_TRANSACTIONS",
        arg: data,
      });
    },
    [transactions]
  );

  const toggleIsFetching = useCallback(
    (state: boolean) => setIsFetching(state),
    [isFetching]
  );

  const fetchTxns = useCallback(
    async (userId: string) => {
      if (!isFetching) {
        toggleIsFetching(true);
        await fetchTransactions({
          variables: {
            userId,
          },
        });
      }
    },
    [transactions]
  );

  return [fetchTxns, updateTransactions];
}
